import {
  Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ElementRef,
  ViewChild, ContentChild, TemplateRef, Renderer2
} from '@angular/core';
import { SwipeInfo, SwipeDirection } from '../../shared/directives/rm-swiper.directive';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { Listing } from '../../classes/listing';

@Component({
  selector: 'app-card-preview',
  templateUrl: './card-preview.component.html',
  styleUrls: [
    './card-preview.component.scss',
    './card-preview.component.desktop.scss'
  ],
  animations: [
    trigger('previewTrigger', [
      state('hidden', style({
        bottom: '-500px',
        opacity: 0
      })),
      state('shown', style({
        bottom: '0',
        opacity: 1,
      })),
      state('empty', style({
        bottom: '500px',
        opacity: 0
      })),
      transition('hidden <=> shown', animate('250ms ease-in')),
      transition('* => empty', animate('100ms ease-out'))
    ])
  ]
})

export class CardPreviewComponent implements OnInit, OnChanges {
  @Input() cards: Listing[];
  @Input() enableClosePreviewCards: boolean = true;
  @Input() isAbsolutePosition: boolean = true;
  @Input() initialCardIndex: number = 0;
  @Input() selectedListingIndex: string = '';
  @Output() cardClicked = new EventEmitter<any>();
  @Output() cardFocused = new EventEmitter<any>();
  @Output() swipedUpOnCard = new EventEmitter<Listing>();
  @Output() hidePreview = new EventEmitter<void>();

  @ContentChild(TemplateRef) cardContentTemplate: TemplateRef<any>;
  @ViewChild('cardPreviewRef') listingPreviewRef: ElementRef;

  currentCardIndex: number;
  state: string = 'hidden';

  private _thresholdForVerticalSwiping: number = 30;

  constructor(private _renderer: Renderer2
  ) {};

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.cards) {
      // switching between clusters
      if (changes.cards.previousValue === undefined || changes.cards.previousValue.length === 0) {
        this.state = 'hidden';
        this.currentCardIndex = this.initialCardIndex;

        if (changes.cards.currentValue.length === 0) this.state = 'empty';
        else {
          setTimeout(() => {
            this.state = 'shown';
          }, 150);
        }
      }
      // Pagination of cluster
      else if (changes.cards.previousValue) {}
    }
  }

  swipeTogglePreview(event: SwipeInfo) {
    event.swipeEvent.stopPropagation();
    // TODO: put an animation for this
    const calcVal = event.y.current - event.y.start;
    if (event.swipeEvent.type === 'touchmove') {
      if (calcVal > 0)
        this._renderer.setStyle(this.listingPreviewRef.nativeElement, 'transform', 'translateY(' + calcVal + 'px)');
      else
        this._renderer.setStyle(this.listingPreviewRef.nativeElement, 'transform', 'translateY(0px)');
    }
    else if (event.swipeEvent.type === 'touchend') {
      if (Math.abs(event.y.current - event.y.start) > this._thresholdForVerticalSwiping) {
        if (event.y.direction === SwipeDirection.DOWN) this.hidePreview.emit();
        else if (event.y.direction === SwipeDirection.UP) this.swipedUpOnCard.emit(this.cards[this.currentCardIndex]);
      }
      this._renderer.setStyle(this.listingPreviewRef.nativeElement, 'transform', 'translateY(0px)');
    }
  }

  trackBy(index, card: Listing) {
    return card.id;
  }

  slideChanged(event: {card: Listing, index: number}) {
    this.currentCardIndex = event.index;
    this.cardFocused.emit(event);
  }


}


